function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgButtonPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "play button",
  viewBox: "0 0 122 86"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    opacity: 0.85
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M1160-318h-102a10 10 0 0 0-10 10v66a10 10 0 0 0 10 10h102a10 10 0 0 0 10-10v-66a10 10 0 0 0-10-10m-29.92 43.42-32.48 18.75a.94.94 0 0 1-1.42-.82v-37.5a1 1 0 0 1 1.42-.83l32.48 18.75a1 1 0 0 1-.01 1.65Z",
  style: {
    fill: "#fff"
  },
  transform: "translate(-1048 318)"
})));
export { SvgButtonPlay as ReactComponent };